import React from "react";
import { Languages } from "lucide-react";
import { useLocale } from "@/contexts/LocaleProvider";
import { cn } from "@/lib/utils";

export default function LanguageSwitcher({ className, compact = false }) {
  const { locale, setLocale } = useLocale();

  async function toggle() {
    await setLocale(locale === "ar" ? "en" : "ar");
  }

  return (
    <button
      type="button"
      onClick={toggle}
      className={cn(
        "inline-flex items-center gap-1.5 rounded-md border border-slate-200 bg-white px-2.5 py-1.5 text-[11px] font-semibold text-slate-700 hover:bg-slate-50",
        className,
      )}
      data-testid="language-switcher"
      title={locale === "ar" ? "Switch to English" : "التبديل إلى العربية"}
    >
      <Languages size={14} className="shrink-0" />
      {!compact && <span>{locale === "ar" ? "EN" : "عربي"}</span>}
    </button>
  );
}
